import React from 'react';
import { Button } from "@mui/material";
import axios from "axios";
import {
    convertDateToBallCalendar
} from "../../components/FormZero/PageComponents/FormPane/SubComponents/Form_WeekSelection";

function xml_to_json(xml: any) {
    try {
        let obj: any = {};
        if (xml.children.length > 0) {
            for (let i = 0; i < xml.children.length; i++) {
                let child = xml.children[i];
                let temp = xml_to_json(child);
                let local: any = {};
                for (let i = 0; i < child.attributes.length; i++) {
                    let attribute = child.attributes[i];
                    local[attribute.name] = attribute.value;
                }
                if (obj[child.localName] !== undefined && !Array.isArray(obj[child.localName])) {
                    // convert to array
                    obj[child.localName] = [obj[child.localName], { ...temp, ...local }];
                }
                else if (obj[child.localName] === undefined) {
                    obj[child.localName] = { ...temp, ...local };
                }
                else {
                    obj[child.localName].push({ ...temp, ...local });
                }
            }
        }
        return obj;
    }
    catch (e: any) {
        console.log(e.message)
        return {};
    }
}

function parseXMLFile(fileContents: any, uploadListToServer: any) {
    let parser, xmlDoc;
    parser = new DOMParser();
    xmlDoc = parser.parseFromString(fileContents, "text/xml");
    // console.log(xmlDoc.length);
    // console.log(xmlDoc);
    let response = xml_to_json(xmlDoc);
    // console.log(response);
    uploadListToServer(response)
}

function readFile(uploadListToServer: any) {
    let input = document.createElement('input');
    input.type = 'file';
    input.onchange = _ => {
        // you can use this method to get file and perform respective operations
        let files = Array.from(input.files!);
        const headers = {
            'Content-Type': 'multipart/form-data'
        }
        var bodyFormData = new FormData();
        bodyFormData.append('files', files[0]);
        axios.post(`${process.env.REACT_APP_ENDPOINT}/api/DeliveryHeaders/delivery-list-upload`, bodyFormData, {
            headers: headers
        });
        console.log(files);
        if (files.length > 0) {
            // const name = files[0].name;
            const reader = new FileReader();
            reader.onload = (evt) => { // evt = on_file_select event
                /* Parse data */
                const bstr = evt.target != null ? evt.target.result : null;
                parseXMLFile(bstr, uploadListToServer);
            };
            reader.readAsBinaryString(files[0]);
        }
    };
    input.click();
}


export function DeliveryListUploader() {
    // const {} = props;

    const [output, setOutput] = React.useState({});
    const uploadFileContents = async (BallPurchaseOrder: any) => {
        console.log(BallPurchaseOrder);
        let b = { ...BallPurchaseOrder };
        if (
            !Array.isArray(b.BallPurchaseOrder.OrderDetails.Item)
        ) {
            b.BallPurchaseOrder.OrderDetails.Item = [b.BallPurchaseOrder.OrderDetails.Item];
        }

        let header = { ...b.BallPurchaseOrder.OrderHeader, SoldTo: undefined, ShipTo: undefined };
        Object.keys(b.BallPurchaseOrder.OrderHeader.ShipTo).forEach((key) => header[key] = b.BallPurchaseOrder.OrderHeader.ShipTo[key])
        Object.keys(b.BallPurchaseOrder.OrderHeader.SoldTo).forEach((key) => header[key] = b.BallPurchaseOrder.OrderHeader.SoldTo[key])

        // b.OrderHeader // could flatten the subitems in here.
        let upload = {
            OrderHeader: header,
            OrderItems: b.BallPurchaseOrder.OrderDetails.Item
        }

        setOutput(upload);
    };

    const upload = async () => {
        try {
            let input: any = {
                ...output
            };
            input['OrderHeader'].week_number = convertDateToBallCalendar(input['OrderHeader']['RequestedShipDate']);
            input['OrderHeader'].year = new Date(input['OrderHeader']['RequestedShipDate']).getFullYear();
            // let headerDate = {OrderHeader: {week_number: 1, year: 2022}};
            const response = await axios.post(`${process.env.REACT_APP_ENDPOINT}/api/DeliveryHeaders/delivery-list-upload`
                , input);
            console.log(response);
            // alert(response.status)
            if (response.status === 201) {
                // alert("added");
            }
        } catch (err) {
            // setMessage("Something went wrong", err.response.data.message);
            console.log(err);
        }
    }

    return (
        <>
            <Button onClick={() => readFile(uploadFileContents)}>Parse XML File</Button>
            <Button onClick={() => upload().then}>Upload</Button>
            <pre style={{ height: '800px', overflowY: 'scroll' }}>{JSON.stringify(output, undefined, 4)}</pre>
        </>
    )
}
